/** Initialize epayments as an empty list.
*/

module.exports = Backbone.Model.extend({
  defaults() {
    return {
      epayments: new Backbone.Collection()
    };
  },

  clearEpayments() {
    this.set({
      epayments: new Backbone.Collection()
    });
  }
});



// WEBPACK FOOTER //
// ./epayment_import/models/epayment.js